<template>
  <div class="flex items-center">
    <Slider v-model="val" class="site-ui-slider w-full" v-bind="$attrs" @change="onChange" />
    <input
      v-model="inputValue"
      class="w-[35px] flex-shrink-0 h-[22px] text-center outline-none bg-fillColor-3 rounded-sm flex items-center justify-center"
      @keyup="inputValue=String(inputValue).replace(/^(0+)|[^\d]+/g,'')"
      @input="debounceInput"
    />
  </div>
</template>
<script>
import { Slider } from 'element-ui'
import { debounce } from 'lodash-es'
import {insertStep} from '~/utils/event'

export default {
  name: "MenuSlider",
  components: {
    Slider
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    targetKey: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      val: this.value,
      inputValue: this.value,
      debounceInput: ''
    }
  },
  watch: {
    value() {
      this.val = this.value
      this.inputValue = this.value
    }
  },
  mounted() {
    this.debounceInput = debounce(this.onInput, 500)
  },
  methods: {
    onChange(value) {
      this.inputValue = value
      insertStep(this, [this.targetKey], this.value)
      this.$emit('change', value)
    },
    onInput() {
      const max = 100
      let number = Number(this.inputValue)
      if (number > max) {
        number = max
      }
      this.val = number
      this.onChange(number)
    }
  }
}
</script>

<style lang="less" scoped>
.site-ui-slider {
  padding: 0 6px;
  /deep/ .el-slider__button-wrapper {
    top: -16px;
  }
  /deep/ .el-slider__runway {
    background-color: rgba(255, 255, 255, 0.1);
    height: 4px;
    margin: 4px 0;
    border-radius: 2px;
  }

  /deep/ .el-slider__bar {
    background: var(--primary-color);
    height: 4px;
    border-radius: 2px;
    box-shadow: 0 0 8px rgba(var(--primary-color-rgb), 0.4);
  }

  /deep/ .el-slider__button {
    width: 14px;
    height: 14px;
    background: white;
    border: 2px solid var(--primary-color);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    
    &:hover, &.dragging {
      transform: scale(1.2);
      box-shadow: 0 0 0 4px rgba(var(--primary-color-rgb), 0.2);
    }
  }
}

input {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  font-family: monospace;
  transition: all 0.3s ease;
  height: 24px;
  
  &:focus {
    border-color: var(--primary-color);
    background: rgba(255, 255, 255, 0.08);
    color: white;
    box-shadow: 0 0 0 2px rgba(var(--primary-color-rgb), 0.2);
  }
  
  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.2);
  }
}
</style>
